import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
          <div className="mb-4 md:mb-0">
            <div className="flex items-center space-x-2 mb-2">
              <div className="w-8 h-8 bg-black rounded flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <span className="text-lg font-bold text-black">Worknetix Solutions</span>
            </div>
            <p className="text-sm text-gray-600">Copyright © {currentYear} - All rights reserved.</p>
          </div>
          <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-8 lg:space-x-12">
            <div>
              <h3 className="text-sm font-semibold text-black mb-3 uppercase">Links</h3>
              <ul className="space-y-2">
                <li><Link to="/services" className="text-sm text-gray-600 hover:text-black transition-colors">Services</Link></li>
                <li><Link to="/about" className="text-sm text-gray-600 hover:text-black transition-colors">About</Link></li>
                <li><Link to="/contact" className="text-sm text-gray-600 hover:text-black transition-colors">Contact</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-black mb-3 uppercase">Legal</h3>
              <ul className="space-y-2">
                <li><Link to="/terms" className="text-sm text-gray-600 hover:text-black transition-colors">Terms of Services</Link></li>
                <li><Link to="/privacy" className="text-sm text-gray-600 hover:text-black transition-colors">Privacy Policy</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-black mb-3 uppercase">Contact</h3>
              <ul className="space-y-2">
                <li>
                  <a href="tel:+919920777730" className="text-sm text-gray-600 hover:text-black transition-colors block">
                    +91 99207 77730
                  </a>
                </li>
                <li>
                  <a href="tel:+919930111108" className="text-sm text-gray-600 hover:text-black transition-colors block">
                    +91 99301 11108
                  </a>
                </li>
                <li>
                  <a href="mailto:Worknetixsolutions@gmail.com" className="text-sm text-gray-600 hover:text-black transition-colors block break-all">
                    Worknetixsolutions@gmail.com
                  </a>
                </li>
                <li className="text-sm text-gray-600 mt-3 max-w-xs">
                  FLIGNITE (Worknetix Staffing Solutions Pvt Ltd & Fino Bank), Ground Floor, Parasmani Commercial Complex, Opp Dadar Kailash Lassi Civic Center, Dadar East, Mumbai - 400014, India
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
